export function getAgentConfigSectionDomId(sectionId) {
  return `agent-config-section-${sectionId}`;
}

export function getVisibleNavSections(
  tab,
  { isSystemAgent, isMasterAgent, isCreateMode, agentId }
) {
  const sections = Array.isArray(tab?.sections) ? tab.sections : [];
  return sections.filter((section) => {
    if (section.hideForSystemAgent && isSystemAgent) return false;
    if (section.hideForMasterAgent && isMasterAgent) return false;
    if (section.hideInCreateMode && isCreateMode) return false;
    if (section.requiresAgentId && !agentId) return false;
    return true;
  });
}
